import Button from '@CS/components/Button';
import { type CSSProperties, useState } from 'react';
import { type PopupProps, Popup, FADE_DURATION } from '@CS/components/Popups';

import {
  ConfirmTitle,
  ConfirmMessage,
  ContentContainer,
  ButtonsContainer
} from './Confirmation.styles';

type ConfirmationProps = PopupProps & {
  onSubmit: () => void;
  onCancel: () => void;
};

export const Confirmation = ({
  onSubmit,
  onCancel,
  onClose,
  ...props
}: ConfirmationProps) => {
  const [visible, setVisible] = useState(true);

  const onClick = (confirm: boolean) => {
    setTimeout(confirm ? onSubmit : onCancel, FADE_DURATION);
    setVisible(false);
  };

  const dialogStyle = {
    flexDirection: 'column',
    alignContent: 'center',
    display: 'flex'
  } as CSSProperties;

  return (
    <Popup
      customStyle={dialogStyle}
      onClose={onClose}
      close={!visible}
      {...props}
    >
      <ContentContainer>
        <ConfirmTitle>Wil je echt weg?</ConfirmTitle>

        <ConfirmMessage>
          Als je Avatar Creator nu verlaat, dan raak je je progressie kwijt.
          Alleen volledig aangemaakte Avatars blijven bewaard.
        </ConfirmMessage>
      </ContentContainer>

      <ButtonsContainer>
        <Button
          onClick={() => onClick(false)}
          text="Oké, ik blijf"
          width="100%"
        />

        <Button
          onClick={() => onClick(true)}
          text="Terug naar begin"
          variant="secondary"
          width="100%"
        />
      </ButtonsContainer>
    </Popup>
  );
};
